import React from "react";

type KidneyOption = "hemodialysis" | "capd" | "crrt" | "cct" | null;

interface Props {
	kidneyIssue: boolean;
	kidneyOption: KidneyOption;
	cctValue: string;

	onToggleKidney: () => void;
	onSelectKidneyOption: (val: Exclude<KidneyOption, null>) => void;
	onChangeCctValue: (val: string) => void;
	onOpenEgfrCalculator: () => void;

	radioButtonOn: string;
	radioButtonOnFill: string;
}

export function KidneySection({
	kidneyIssue,
	kidneyOption,
	cctValue,
	onToggleKidney,
	onSelectKidneyOption,
	onChangeCctValue,
	onOpenEgfrCalculator,
	radioButtonOn,
	radioButtonOnFill,
}: Props) {
	const kidneyOptions: { id: Exclude<KidneyOption, null>; label: string }[] = [
		{ id: "hemodialysis", label: "המודיאליזה" },
		{ id: "capd", label: "CAPD" },
		{ id: "crrt", label: "CRRT" },
		{ id: "cct", label: "CCT" },
	];

	return (
		<div className="sensitivity-card">
			<label className="sensitivity-toggle-row">
				<div className="sensitivity-toggle-label">
					<span className="sensitivity-icon">🫘</span>
					<div className="sensitivity-label-with-link">
						<span>חשד לאי ספיקת כליות</span>
					</div>
				</div>

				<button
					type="button"
					className={`toggle-btn ${kidneyIssue ? "on" : "off"}`}
					onClick={onToggleKidney}
					aria-pressed={kidneyIssue}
				>
					<span className="toggle-thumb" />
				</button>
			</label>

			<div className={`sub-options-animate ${kidneyIssue ? "expanded" : ""}`}>
				<div className="sub-options-inner">
					<div className="sub-label">סוג דיאליזה</div>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "12px",
						}}
					>
						{kidneyOptions.map((opt) => {
							const isSelected = kidneyOption === opt.id;
							const isCctOption = opt.id === "cct";

							return (
								<div key={opt.id}>
									<button
										type="button"
										onClick={() => onSelectKidneyOption(opt.id)}
										aria-pressed={isSelected}
										style={{
											display: "inline-flex",
											alignItems: "center",
											gap: "8px",
											border: "none",
											background: "transparent",
											cursor: "pointer",
											padding: 0,
											font: "inherit",
										}}
									>
										<img
											src={isSelected ? radioButtonOnFill : radioButtonOn}
											alt=""
											aria-hidden="true"
											style={{ width: 20, height: 20 }}
										/>
										<span>{opt.label}</span>
									</button>

									{isCctOption && (
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: "12px",
												marginTop: "8px",
												marginRight: "28px",
											}}
										>
											<input
												type="number"
												inputMode="decimal"
												min="0"
												step="0.1"
												value={cctValue}
												onChange={(e) => onChangeCctValue(e.target.value)}
												placeholder="ערך CCT"
												aria-label="CCT value"
												disabled={!isSelected}
												style={{
													width: "140px",
													padding: "8px 12px",
													fontSize: "14px",
													border: "1px solid #CBD5E1",
													borderRadius: "8px",
													opacity: isSelected ? 1 : 0.5,
													outline: "none",
												}}
												onFocus={(e) => {
													if (isSelected) {
														e.target.style.borderColor = "#1FB5A3";
														e.target.style.boxShadow = "0 0 0 2px rgba(31, 181, 163, 0.2)";
													}
												}}
												onBlur={(e) => {
													e.target.style.borderColor = "#CBD5E1";
													e.target.style.boxShadow = "none";
												}}
											/>
											<a
												href="#"
												onClick={(e) => {
													e.preventDefault();
													onOpenEgfrCalculator();
												}}
												style={{
													color: "#1FB5A3",
													textDecoration: "underline",
													fontSize: "14px",
													cursor: "pointer",
												}}
											>
												מחשבון eGfr
											</a>
										</div>
									)}
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
}

export type { KidneyOption };